module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("调课系统")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [_c('el-select', {
    staticStyle: {
      "width": "210px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "xnxqbm", $$v)
      },
      expression: "queryForm.xnxqbm"
    }
  }, _vm._l((_vm.xnxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.auditInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.queryDialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "xnxqbm", $$v)
      },
      expression: "queryForm.xnxqbm"
    }
  }, _vm._l((_vm.xnxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "课程名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "申请类型",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.applyType),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "applyType", $$v)
      },
      expression: "queryForm.applyType"
    }
  }, _vm._l((_vm.applyInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.auditInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有调课信息")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("申请教师：")]), _vm._v(_vm._s(item.creatorName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学年学期：")]), _vm._v(_vm._s(item.xnxqmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("课程名称：")]), _vm._v(_vm._s(item.courseName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("班级名称：")]), _vm._v(_vm._s(item.className))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("申请类型：")]), _vm._v(_vm._s(item.applyTypeName))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.auditState != '-1' && item.auditAuth == '0') ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.showDetailInfo(item);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-tickets"
    }), _vm._v(" 详情\n                    ")]) : _vm._e(), _vm._v(" "), (item.auditAuth == '1') ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.auditRec(item);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-edit-outline"
    }), _vm._v(" 班长确认\n                    ")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "curdForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [(_vm.editType == 'audit' || _vm.editType == 'show') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "申请类型",
      "prop": "applyType"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.applyTypeName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请教师",
      "prop": "applyTeacher"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.applyTeacherName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.majorName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "prop": "classCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.className) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.courseName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调课原因",
      "prop": "adjustReason"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.adjustReasonName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "变更理由",
      "prop": "changeReason"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.curdForm.changeReason) + "\n                        ")]), _vm._v(" "), (_vm.adjustFlag == '1') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "原计划周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原计划星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.yjhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原计划节数"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt((_vm.curdForm.yjhsjxl + ''), 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.tzhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调整后节数"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt((_vm.curdForm.tzhsjxl + ''), 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskjsxm + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', [_vm._v("\n                                    " + _vm._s(_vm.yjhsiteList[i].name + '') + " ===》 " + _vm._s(_vm.tzhsiteList[i].name + '') + "\n                                ")])
  }), 0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其它说明",
      "prop": "otherExplain"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.otherExplain) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '4') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "代课周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代课星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.yjhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代课节数"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt((_vm.curdForm.yjhsjxl + ''), 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, _vm._l((_vm.yjhteaList), function(site, i) {
    return _c('div', [_vm._v("\n                                    " + _vm._s(_vm.yjhteaList[i].name + '') + " ===》 " + _vm._s(_vm.tzhteaList[i].name + '') + "\n                                ")])
  }), 0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', [_vm._v("\n                                    " + _vm._s(_vm.yjhsiteList[i].name + '') + " ===》 " + _vm._s(_vm.tzhsiteList[i].name + '') + "\n                                ")])
  }), 0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其它说明",
      "prop": "otherExplain"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.otherExplain) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '3') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "补课周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "补课星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.tzhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "补课节数"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt((_vm.curdForm.tzhsjxl + ''), 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhskjsxm + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.tzhcdmc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其它说明",
      "prop": "otherExplain"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.otherExplain) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '2') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "停课周数"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskzc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "停课星期"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt(_vm.curdForm.yjhxq, 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "停课节数"
    }
  }, [_vm._v("\n                                " + _vm._s(parseInt((_vm.curdForm.yjhsjxl + ''), 10)) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhskjsxm + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.yjhcdmc + '') + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其它说明",
      "prop": "otherExplain"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.otherExplain) + "\n                            ")])], 1) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.operateButtonVisible) ? _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.auditDisabled == false && _vm.editType != 'show') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.saveRec()
      }
    }
  }, [_vm._v("保 存")]) : _vm._e(), _vm._v(" "), (_vm.auditDisabled == false && _vm.editType != 'show') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.submitRec()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.auditDisabled == true && _vm.editType != 'show') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.auditOption();
      }
    }
  }, [_vm._v("学生意见")]) : _vm._e(), _vm._v(" "), (_vm.editType != 'show') ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.auditAreaVisible) ? _c('el-dialog', {
    staticClass: "formDialog xsyjDialog",
    attrs: {
      "title": "学生意见",
      "visible": _vm.auditAreaVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditAreaVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px",
      "height": "160px"
    }
  }, [_c('monitorAudit', {
    key: _vm.timer,
    ref: "audit",
    attrs: {
      "itemCode": _vm.queryForm.itemCode,
      "relatedCode": _vm.selectRowData.id,
      "auditLevel": _vm.curdForm.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7813dfb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/adjustMonitor.vue
// module id = 1867
// module chunks = 502